export class ToggleChangeEvent extends CustomEvent<{ payload: boolean }> {
   static EVENT_NAME = 'onToggle';
   constructor(payload: boolean) {
      super(ToggleChangeEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
         detail: { payload },
      });
   }
}
